var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"pa-5",attrs:{"id":"unauthorized"}},[_c('h2',[_vm._v("Unauthorized")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Go Back ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }